(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1566],{

/***/ 68:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ A; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/A/AStyle.ts



var AStyle = es/* StyleSheet.create */.mM.create({
  a: {
    textDecoration: "none",
    margin: 0,
    padding: 0,
    color: colorStyle/* accentColor.primaryColor */.z.primaryColor
  },
  inline: {
    textDecoration: "underline",
    margin: 0,
    padding: 0,
    color: colorStyle/* accentColor.primaryColor */.z.primaryColor,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/A/A.tsx


var _excluded = ["styles", "children", "styleKey"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var A = function A(props) {
  var styles = props.styles,
      children = props.children,
      _props$styleKey = props.styleKey,
      styleKey = _props$styleKey === void 0 ? "a" : _props$styleKey,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", _objectSpread(_objectSpread({
    className: (0,es/* css */.iv)(AStyle[styleKey], styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 99931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* reexport safe */ _A__WEBPACK_IMPORTED_MODULE_0__.A; }
/* harmony export */ });
/* harmony import */ var _A__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68);


/***/ }),

/***/ 20455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Paragraph/ParagraphStyle.tsx




var ParagraphStyle = es/* StyleSheet.create */.mM.create({
  paragraph: {
    fontSize: typographyStyle/* fontSize.body */.JB.body,
    lineHeight: typographyStyle/* lineHeight.body1 */.Nv.body1,
    fontWeight: typographyStyle/* fontWeight.regular */.Ue.regular,
    color: colorStyle/* textColor.secondaryDarkColor */.zP.secondaryDarkColor,
    margin: 0,
    padding: spaceStyle/* space.atom */.D.atom,
    wordWrap: "break-word"
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Paragraph/Paragraph.tsx


var _excluded = ["styles", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Paragraph = function Paragraph(props) {
  var styles = props.styles,
      children = props.children,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", _objectSpread(_objectSpread({
    className: (0,es/* css */.iv)(ParagraphStyle.paragraph, styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 10798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* reexport safe */ _Paragraph__WEBPACK_IMPORTED_MODULE_0__.n; }
/* harmony export */ });
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20455);


/***/ }),

/***/ 59630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ Debug; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Debug/DebugStyle.ts




var DebugStyle = es/* StyleSheet.create */.mM.create({
  block: {
    margin: "auto",
    padding: spaceStyle/* space.block */.D.block,
    boxSizing: "border-box",
    textAlign: "center",
    position: "relative"
  },
  p: {
    color: "#000",
    fontSize: typographyStyle/* fontSize.caption */.JB.caption
  },
  pDark: {
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    fontSize: typographyStyle/* fontSize.caption */.JB.caption
  }
});
// EXTERNAL MODULE: ./main/javascripts/components/atoms/A/A.tsx + 1 modules
var A = __webpack_require__(68);
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Paragraph/index.ts
var Paragraph = __webpack_require__(10798);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Debug/Debug.tsx






var Debug =  false ? 0 : function (props) {
  var currentUser = props.currentUser;

  if (!currentUser) {
    return null;
  }

  var href = "/users/sign_out";
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    className: (0,es/* css */.iv)(DebugStyle.block),
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
      href: href,
      title: "login",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
        styles: DebugStyle.p,
        children: "> ログアウト"
      })
    })
  });
}; // : (_: any): null => {
//     return null;
//   };
;// CONCATENATED MODULE: ./main/javascripts/components/molecules/Debug/index.ts


/***/ }),

/***/ 61566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Footer": function() { return /* reexport */ Footer; },
  "FooterStyle": function() { return /* reexport */ FooterTravelvision_FooterStyle; },
  "FooterTravelvision": function() { return /* reexport */ FooterTravelvision; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/aphrodite/es/index.js + 1 modules
var es = __webpack_require__(34397);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./main/javascripts/styles/base/spaceStyle.ts
var spaceStyle = __webpack_require__(96749);
// EXTERNAL MODULE: ./main/javascripts/styles/base/typographyStyle.ts
var typographyStyle = __webpack_require__(36716);
// EXTERNAL MODULE: ./main/javascripts/styles/base/colorStyle.ts
var colorStyle = __webpack_require__(80910);
// EXTERNAL MODULE: ./main/javascripts/styles/base/borderStyle.ts
var borderStyle = __webpack_require__(58589);
// EXTERNAL MODULE: ./main/javascripts/styles/base/responsiveStyle.ts
var responsiveStyle = __webpack_require__(88433);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Footer/FooterStyle.ts


var _col;







var FooterStyle = es/* StyleSheet.create */.mM.create({
  footer: {
    backgroundColor: colorStyle/* backgroundColor.secondaryLightColor */.Cz.secondaryLightColor,
    color: "#000",
    padding: "3rem 0"
  },
  mainBlock: {
    maxWidth: "67.25rem",
    display: "flex",
    flexFlow: "row wrap",
    margin: "0 auto 0 auto",
    alignItems: "stretch",
    justifyContent: "space-between"
  },
  col: (_col = {
    width: "100%"
  }, (0,defineProperty/* default */.Z)(_col, (0,responsiveStyle/* equalBreakpoint */.Wc)("tablet"), {
    width: "50%"
  }), (0,defineProperty/* default */.Z)(_col, (0,responsiveStyle/* equalBreakpoint */.Wc)("desktop"), {
    width: "32%"
  }), _col),
  p: {
    color: "#000",
    fontSize: typographyStyle/* fontSize.caption */.JB.caption
  },
  subtitle: {
    color: "#000",
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    fontSize: typographyStyle/* fontSize.body */.JB.body
  },
  block: {
    padding: spaceStyle/* space.block */.D.block,
    boxSizing: "border-box",
    textAlign: "left",
    position: "relative"
  },
  copyrightBlock: {
    maxWidth: "67.25rem",
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    margin: "auto",
    padding: "".concat(spaceStyle/* space.atom3x */.D.atom3x, " ").concat(spaceStyle/* space.atom2x */.D.atom2x, " ").concat(spaceStyle/* space.atom2x */.D.atom2x),
    boxSizing: "border-box",
    position: "relative"
  },
  logo: {
    height: "2.625rem",
    display: "block",
    padding: "".concat(spaceStyle/* space.atom1_5x */.D.atom1_5x, " ").concat(spaceStyle/* space.atom */.D.atom)
  },
  lineBlock: {
    boxSizing: "border-box",
    padding: spaceStyle/* space.atom */.D.atom
  },
  line: {
    display: "block",
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    fontWeight: typographyStyle/* fontWeight.bold */.Ue.bold,
    textDecoration: "none",
    color: colorStyle/* accentColor.lineColor */.z.lineColor,
    border: "1px solid ".concat(colorStyle/* accentColor.lineColor */.z.lineColor),
    padding: spaceStyle/* space.atom */.D.atom,
    borderRadius: borderStyle/* borderRadius.normal */.E.normal,
    boxSizing: "border-box",
    textAlign: "center"
  },
  tel: {
    fontSize: typographyStyle/* fontSize.caption */.JB.caption,
    padding: spaceStyle/* space.atom */.D.atom,
    lineHeight: typographyStyle/* lineHeight.body1 */.Nv.body1
  },
  hr: {
    padding: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " 0"),
    margin: "".concat(spaceStyle/* space.atom */.D.atom, " ").concat(spaceStyle/* space.atom */.D.atom, " 0"),
    boxSizing: "border-box",
    borderColor: "inherit"
  }
});
// EXTERNAL MODULE: ./main/javascripts/components/atoms/Paragraph/index.ts
var Paragraph = __webpack_require__(10798);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Img/ImgStyle.ts


var ImgStyle = es/* StyleSheet.create */.mM.create({
  img: {
    boxSizing: "border-box",
    padding: spaceStyle/* space.atom */.D.atom
  }
});
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Img/Img.tsx


var _excluded = ["styles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Img = function Img(props) {
  var styles = props.styles,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", _objectSpread({
    className: (0,es/* css */.iv)(ImgStyle.img, styles)
  }, rest));
};
;// CONCATENATED MODULE: ./main/javascripts/components/atoms/Img/index.ts

// EXTERNAL MODULE: ./main/javascripts/components/atoms/A/index.ts
var A = __webpack_require__(99931);
// EXTERNAL MODULE: ./main/javascripts/components/molecules/Debug/index.ts + 2 modules
var Debug = __webpack_require__(59630);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./main/javascripts/images/logo_black.svg
var logo_black = __webpack_require__(24450);
var logo_black_default = /*#__PURE__*/__webpack_require__.n(logo_black);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Footer/Footer.tsx






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }












var Footer = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(Footer, _React$Component);

  var _super = _createSuper(Footer);

  function Footer() {
    (0,classCallCheck/* default */.Z)(this, Footer);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Footer, [{
    key: "render",
    value: function render() {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("footer", {
        className: (0,es/* css */.iv)(FooterStyle.footer),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,es/* css */.iv)(FooterStyle.mainBlock),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,es/* css */.iv)(FooterStyle.block, FooterStyle.col),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
              href: "/",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Img, {
                src: (logo_black_default()),
                alt: "\u305F\u3073\u30C1\u30E3\u30C3\u30C8 - \u65C5\u884C\u30B3\u30F3\u30B7\u30A7\u30EB\u30B8\u30E5\u30B5\u30FC\u30D3\u30B9",
                styles: FooterStyle.logo
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
              className: (0,es/* css */.iv)(FooterStyle.hr)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
              styles: FooterStyle.p,
              children: "\u65C5\u884C\u6848\u5185LINE\u30A2\u30AB\u30A6\u30F3\u30C8\u300C\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u300D\u306F\u3001\u3042\u306A\u305F\u306E\u5E0C\u671B\u306B\u5408\u308F\u305B\u3066\u30DB\u30C6\u30EB\u3001\u79FB\u52D5\u624B\u6BB5\u3001\u73FE\u5730\u30C4\u30A2\u30FC\u3092\u6848\u5185\u3057\u307E\u3059\u3002"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
              className: (0,es/* css */.iv)(FooterStyle.tel),
              children: "\u30AB\u30B9\u30BF\u30DE\u30FC\u30B5\u30DD\u30FC\u30C8: 03-6304-0770"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,es/* css */.iv)(FooterStyle.block, FooterStyle.col),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
              styles: FooterStyle.subtitle,
              children: "\u25A0 \u904B\u55B6\u4F1A\u793E\u306B\u3064\u3044\u3066"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
              className: (0,es/* css */.iv)(FooterStyle.hr)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "http://nin-nin.net",
              title: "\u4F1A\u793E\u6982\u8981",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paragraph/* Paragraph */.n, {
                styles: FooterStyle.p,
                children: [">", " \u4F1A\u793E\u60C5\u5831"]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "".concat(Constants/* PATH_SCOPE */.j1, "/statics/service_policy"),
              title: "\u5229\u7528\u898F\u7D04",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paragraph/* Paragraph */.n, {
                styles: FooterStyle.p,
                children: [">", " \u5229\u7528\u898F\u7D04"]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "".concat(Constants/* PATH_SCOPE */.j1, "/statics/travel_agency_act"),
              title: "\u65C5\u884C\u696D\u767B\u9332\u7968",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paragraph/* Paragraph */.n, {
                styles: FooterStyle.p,
                children: [">", " \u65C5\u884C\u696D\u767B\u9332\u7968"]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "/reputation",
              title: "\u305F\u3073\u30C1\u30E3\u30C3\u30C8\u306E\u8A55\u5224",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paragraph/* Paragraph */.n, {
                styles: FooterStyle.p,
                children: [">", " \u305F\u3073\u30C1\u30E3\u30C3\u30C8\u306E\u8A55\u5224"]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "/engine",
              title: "\u30BF\u30D3\u30C1\u30E3\u30C3\u30C8\u30A8\u30F3\u30B8\u30F3",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paragraph/* Paragraph */.n, {
                styles: FooterStyle.p,
                children: [">", " \u30DB\u30C6\u30EB\u4E88\u7D04\u30B7\u30B9\u30C6\u30E0\u300C\u30BF\u30D3\u30C1\u30E3\u30C3\u30C8\u30A8\u30F3\u30B8\u30F3\u300D"]
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,es/* css */.iv)(FooterStyle.block, FooterStyle.col),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
              styles: FooterStyle.subtitle,
              children: "\u25A0 \u65C5\u884C\u696D\u767B\u9332\u306B\u3064\u3044\u3066"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("hr", {
              className: (0,es/* css */.iv)(FooterStyle.hr)
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Paragraph/* Paragraph */.n, {
              styles: FooterStyle.p,
              children: ["\u767B\u9332\u756A\u53F7\uFF1A\u65C5\u884C\u696D \u7B2C3-7312\u53F7 ", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\u6240\u5C5E\u5354\u4F1A\uFF1A\u4E00\u822C\u793E\u56E3\u6CD5\u4EBA \u5168\u56FD\u65C5\u884C\u696D\u5354\u4F1A", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), "\u904B\u55B6\u4F1A\u793E\uFF1A\u682A\u5F0F\u4F1A\u793ENinNin"]
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
          className: (0,es/* css */.iv)(FooterStyle.copyrightBlock),
          children: "Copyright \xA9\uFE0E NinNin, Inc. All rights reserved."
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Debug/* Debug */.c, {
          currentUser: this.props.currentUser
        })]
      });
    }
  }]);

  return Footer;
}(react.Component);
// EXTERNAL MODULE: ./main/javascripts/styles/gridStyle.ts
var gridStyle = __webpack_require__(28488);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Footer/FooterTravelvision.tsx







function FooterTravelvision_createSuper(Derived) { var hasNativeReflectConstruct = FooterTravelvision_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function FooterTravelvision_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }













var FooterTravelvision = /*#__PURE__*/function (_React$Component) {
  (0,inherits/* default */.Z)(FooterTravelvision, _React$Component);

  var _super = FooterTravelvision_createSuper(FooterTravelvision);

  function FooterTravelvision() {
    (0,classCallCheck/* default */.Z)(this, FooterTravelvision);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(FooterTravelvision, [{
    key: "render",
    value: function render() {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("footer", {
        className: (0,es/* css */.iv)(FooterTravelvision_FooterStyle.footer),
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
          className: (0,es/* css */.iv)(FooterTravelvision_FooterStyle.mainBlock, gridStyle/* gridStyle.grid */.R.grid),
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,es/* css */.iv)(FooterTravelvision_FooterStyle.block, gridStyle/* gridStyle.col6 */.R.col6),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "/pages/index.html",
              title: "\u4F1A\u793E\u6982\u8981",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
                styles: FooterTravelvision_FooterStyle.link,
                children: "\u904B\u55B6\u4F1A\u793E"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "/",
              title: "Travelvision",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
                styles: FooterTravelvision_FooterStyle.link,
                children: "Travelvision"
              })
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            className: (0,es/* css */.iv)(FooterTravelvision_FooterStyle.block, gridStyle/* gridStyle.col6 */.R.col6),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "/pages/privacypolicy.html",
              title: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
                styles: FooterTravelvision_FooterStyle.link,
                children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(A.A, {
              href: "/pages/kiyaku",
              title: "\u5229\u7528\u898F\u7D04",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Paragraph/* Paragraph */.n, {
                styles: FooterTravelvision_FooterStyle.link,
                children: "\u5229\u7528\u898F\u7D04"
              })
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Debug/* Debug */.c, {
          currentUser: this.props.currentUser
        })]
      });
    }
  }]);

  return FooterTravelvision;
}(react.Component);
var FooterTravelvision_FooterStyle = es/* StyleSheet.create */.mM.create({
  footer: {
    backgroundColor: colorStyle/* backgroundColor.primaryLightColor */.Cz.primaryLightColor,
    boxShadow: "0 -3px 10px rgb(0, 0, 0, 0.08)",
    paddingBottom: "3rem"
  },
  mainBlock: {
    maxWidth: responsiveStyle/* maxBreakpoint.small */.Ns.small,
    margin: "auto",
    padding: "2.5rem 0"
  },
  block: {
    margin: "auto",
    padding: spaceStyle/* space.block */.D.block,
    boxSizing: "border-box",
    textAlign: "center",
    position: "relative"
  },
  logo: (0,defineProperty/* default */.Z)({
    height: "1.5rem",
    width: "auto",
    transform: "translateX(-3%)"
  }, (0,responsiveStyle/* moreThanBreakpoint */.h6)("desktop"), {
    height: "2rem"
  }),
  link: {
    color: colorStyle/* textColor.primaryDarkColor */.zP.primaryDarkColor,
    textDecoration: "none",
    letterSpacing: typographyStyle/* letterSpacing.text */.rX.text,
    fontSize: typographyStyle/* fontSize.body */.JB.body,
    opacity: 0.7,
    transition: "opacity 0.3s ease",
    ":hover": {
      opacity: 1
    }
  }
});
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/Footer/index.ts



/***/ }),

/***/ 24450:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ })

}]);